'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPhone = function TiPhone(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.3 11.8l6.2-6.2-0.8-0.7c-0.9-0.9-2.5-0.9-3.5 0l-2.6 2.6c-0.5 0.5-0.8 1.1-0.8 1.8s0.3 1.3 0.8 1.8l0.7 0.7z m-11.2 9.8c-1-1-2.6-1-3.6 0l-2.6 2.6c-0.5 0.5-0.7 1.1-0.7 1.8s0.2 1.3 0.7 1.7l0.7 0.8 6.2-6.2-0.7-0.7z m19.6-13.7l-0.6-0.6-6.1 6.2 1 1.1c0.2 0.1 0.3 0.3 0.3 0.5s-0.1 0.5-0.3 0.6l-9.3 9.3c-0.3 0.4-0.8 0.4-1.1 0l-1.1-1-6.2 6.1 0.6 0.6c0.4 0.5 2.1 1.9 5.1 1.9 2.7 0 7.1-1.2 12.7-6.9 11.3-11.3 5.3-17.5 5-17.8z' })
        )
    );
};

exports.default = TiPhone;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/phone.js
// module id = 3916
// module chunks = 0